export default  {

    content:[
      {
        "headline": "Archaeology news: Golden eagle carved into volcanic rock discovered in Aztec temple",
        "description": "ARCHAEOLOGISTS carrying out excavations in an ancient Aztec temple have discovered a carving of a golden eagle dating back more than 600 years.",
        "image": "https://cdn.images.express.co.uk/img/dynamic/151/590x/archaeology-news-aztec-1393552.webp?r=1612600956358",
        "link": "https://www.express.co.uk/news/science/1393552/archaeology-news-aztec-empire-golden-eagle-templo-mayor-evg",
        "author": "Sean Martin",
        "source": "Daily Express",
        "tags": "Aztec, Carving, temple, Eagle, Mexico"
      },
      {
        "headline": "THE QUEEN OF EL PERÚWAKA’",
        "description": "NEW DISCOVERIES IN AN ANCIENT MAYA TEMPLE",
        "image": "https://4.bp.blogspot.com/-s7NdeexZXcQ/UHDZWkYbVhI/AAAAAAAAK8s/g29RgWwiUnw/w1200-h630-p-k-no-nu/Queen+K'Abel+from+el-Peru-Waka'+2012+10.JPG",
        "link": "http://media.cleveland.com/science_impact/other/The%20Queen%20of%20El%20Peru%20Waka,%20Guatemala.pdf",
        "author": "Enrico De Lazaro",
        "source": "Sci-News",
        "tags": "Maya, tomb, mummies, mummy, stone, stele, ancient, queen, guatemala, central ameria"
      },
      {
        "headline": "Does the Brewer Cave Story Unlock a Hidden History?",
        "description": "This sensational story opened up a whole new level of connections with other similar discoveries, furthering the possibility that there actually might be some truth to the hard-to-believe story of ancient giants.",
        "image": "https://www.ancient-origins.net/sites/default/files/field/image/brewer-cave.jpg",
        "link": "https://www.ancient-origins.net/myths-legends-americas/brewer-cave-0012778",
        "author": "Aleksa Vuckovic",
        "source": "Ancient-Origins",
        "tags": "Brewer's Cave, Giants, Plates, Sanpete, Manti, Terry Carter, John, Red Hair, Mummies"
      },
      {
        "headline": "Archaeologists looking for Stonehenge origins 'are digging in wrong place'",
        "description": "For almost a century archaeologists have been braving the wind and rain on an exposed Welsh hillside in an attempt to solve one of the key mysteries of Stonehenge.",
        "image": "http://static.guim.co.uk/sys-images/Guardian/Pix/pictures/2013/11/20/1384955775230/Stonehenge-011.jpg",
        "link": "http://archaeology-in-europe.blogspot.com/2013/11/",
        "author": "David Beard",
        "source": "Archaeology in Europe News",
        "tags": "For almost a century archaeologists have been braving the wind and rain on an exposed Welsh hillside in an attempt to solve one of the key mysteries of Stonehenge."
      },
      {
        "headline": "Mysterious Petroglyphs in the Western US",
        "description": "Accross the Western United States a mystery is unfolding.",
        "image": "https://storage.googleapis.com/rockiestocumorahserver.appspot.com/rockiestocumorah/mystery-glyphs/mystery-glyph-fillmore-3.JPG",
        "link": "http://www.mysteryglyphs.com/pages/Articles/20061029-002A.pdf",
        "author": "Terry Carter and Shawn Davies",
        "source": "Mystery Glyphs",
        "tags": "Mystery Glyphs, Petroglyphs, Hieroglyphs, Egyptian, Mayan, Aztec, Western United States"
      },
      {
        "headline": "Translation of Cedar City MysteryGlyphs",
        "description": "Jose Davila interprets the mysterious writings.",
        "image": "https://scienceviews.com/indian/images/SIA0204.jpg",
        "link": "http://www.mysteryglyphs.com/pages/Articles/20090629_0002A.pdf",
        "author": "Jose Davila",
        "source": "From the files of Terry Carter",
        "tags": "Cedar City, Jose Davilla, Terry Carter, Petroglyphs, Hieroglyphs, Mystery Glyphs, Mysteryglyphs"
      }
     ]
}